// extracted by mini-css-extract-plugin
export default {"wrapper":"WrapperDropdownNav_wrapper__XWHQ7"};